import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "lib";
import { useSettingsState } from "views/SettingsView/useSettingsStore";
import { Outlet } from "react-router-dom";
import { toMuiLanguageCode } from "lib/theme/toMuiLanguageCode";

export default function Routes() {
  const { theme, language } = useSettingsState();
  const lang = toMuiLanguageCode(language);
  return (
    <ThemeProvider mode={theme} locale={lang}>
      <CssBaseline />
      <Outlet />
    </ThemeProvider>
  );
}
